import DataItemListPagingResultModelBase from '../_generated/modelBases/data-item-list-paging-result-model-base';

export default class DataItemListPagingResultModel extends DataItemListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
